/**
 * @generated SignedSource<<d734b2f6a2dbac5db36a91304da684e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KeyPerformanceStats_artist$data = {
  readonly displayName: string;
  readonly luminateWeekDatas: ReadonlyArray<{
    readonly value: number | null;
    readonly weekStartDay: any | null;
  } | null> | null;
  readonly " $fragmentType": "KeyPerformanceStats_artist";
};
export type KeyPerformanceStats_artist$key = {
  readonly " $data"?: KeyPerformanceStats_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"KeyPerformanceStats_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KeyPerformanceStats_artist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ISRCWeekDataAggregate",
      "kind": "LinkedField",
      "name": "luminateWeekDatas",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekStartDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "1429cfdcc0397a06e640d0b51761ad8c";

export default node;
